import axios from 'axios';
import * as dotenv from 'dotenv';

dotenv.config();

// import querystring from 'querystring';



function getUrlVars() {
    var vars: any = {};
    function upperToHyphenLower(m: string, key: number, value: string): string {
        vars[key] = value;
        return value;
    }
    // eslint-disable-next-line
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, upperToHyphenLower);
    return vars;
}

/**
 * Gets a parameter value from a URL query string.
 * @param parameter Parameter name.
 * @param defaultvalue Default value to return if parameter is not found.
 * @returns Parameter value.
 */
function getUrlParam(parameter: string, defaultvalue?: string): string {
    var urlparameter = defaultvalue as string;
    if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = (getUrlVars() as any)[parameter];
    }
    return urlparameter;
}

/**
 * Gets a genesys client credentials based on parameters.
 * @param clientId Inflow Client Id generated by Multitenant.
 * @returns Inflow client details object as a Promise.
 */
function getClientCredentials(clientId: string): Promise<any> {
    return axios.get(`${process.env.REACT_APP_INFLOW_API}apps/client/${clientId}`, {params: {
        account: process.env.REACT_APP_INFLOW_API_ACCOUNT_SID,
        token: process.env.REACT_APP_INFLOW_API_AUTH_TOKEN
    }});
}

export {
    getClientCredentials,
    getUrlParam
}